import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';
import LOOKUP from 'constants/lookup';
import GenericTable from 'screens/components/advanced/GenericTable';

class OrderPrintInvoice extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const p = this.props;
        const line = '-------------------------------------------------------';
        const width = '850px';
        const style = {
            width: width,
            height: 'auto'
        };
        const inline = {
            display: 'inline'
        }
        let order = this.props.order

        return p.order ? (
            <div id={p.name} style={{ display: 'none' }}>
                <div style={style} id={p.name + '-content'} className="printable p-3">
                    <div className="row m-2">
                        <h3 className="col-lg-12"><b>Invoice</b></h3>
                    </div>
                    <div className="row m-2">
                        <h4 className="col-lg-12"><b>Invoice Number</b>&nbsp; {order.id}</h4>
                        <h4 className="col-lg-12"><b>Invoice Created Date</b>&nbsp; {moment(order.createdDate).format("yyyy-MM-DD hh:mm A")}</h4>
                        {order.status == "Completed" ? <h4 className="col-lg-12"><b>Completed Date</b>&nbsp; {moment(order.completedDate).format("yyyy-MM-DD hh:mm A")}</h4> : null}
                    </div>
                    <div className="row mb-2">
                        <table className="col-lg-12 w-100">
                            <tr>
                                {order.patientId != 0 &&
                                    <td className="text-left">
                                        <h4>Customer Information</h4>
                                        <div>{p.order.patientFirstName} {p.order.patientLastName}</div>
                                        <div>{p.order.patientPhoneNumber}</div>
                                        <div>{p.order.patientEmail}</div>
                                        <div>&nbsp;</div>
                                    </td>
                                }
                                <td className="text-left">
                                    <h4>Store Information</h4>
                                    <div>{p.store.name}</div>
                                    <div>{p.store.phone}</div>
                                    <div>{p.store.street}, {p.store.city}, {p.store.provinceState}</div>
                                    <div>{p.store.postalCode}</div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div className="row">
                        <h4 className="col-lg-12">Items</h4>
                        <div className="col-lg-12">
                            <GenericTable
                                className="table_center order_detail_table table_no_padding tableHeaderwhiteColorFont"
                                multiSelectable={false}
                                enableSelectAll={false}
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                displayRowCheckbox={false}
                                selectable={true}
                                columns={LOOKUP.menu.admin.orderDetail.tableColumns}
                                rows={this.props.getProducts()}
                                stripedRows={true}
                            />
                        </div>
                    </div>
                    <hr />
                    <div className="row d-flex" style={{ display: 'flex' }}>
                        <div class="col-md-6  p-2" style={{ flex: `0 0 60%` }}>
                            <h4 className="nowrap">{LOOKUP.menu.admin.orderDetail.labels.subTotal}: ${(order.subTotal ? order.subTotal : Number(0)).toFixed(2)}</h4>
                            <h4 className="nowrap">{LOOKUP.menu.admin.orderDetail.labels.discountOnProduct}: ${((order.subTotal - order.subTotalIncludingDiscounts) ? (order.subTotal - order.subTotalIncludingDiscounts) : Number(0)).toFixed(2)}</h4>
                            <h4 className="nowrap">{LOOKUP.menu.admin.orderDetail.labels.subTotalIncludingDiscount}: ${(order.subTotalIncludingDiscounts ? order.subTotalIncludingDiscounts : Number(0)).toFixed(2)}</h4>
                            {

                                order && order.taxesRate && order.taxesRate.length > 0 && order.taxesRate.map(t => (<h4 className="nowrap">{t.name}: ${(t.value ? t.value : Number(0)).toFixed(2)}</h4>))

                            }
                            <h4 className="nowrap">{LOOKUP.menu.admin.orderDetail.labels.total}: ${(order.total ? order.total : Number(0)).toFixed(2)}</h4>
                            <h4 className="nowrap">{LOOKUP.menu.admin.orderDetail.labels.paid}: ${((order.total - order.balanceDue) ? (order.total - order.balanceDue) : Number(0)).toFixed(2)}</h4>
                            <h4 className="nowrap">{LOOKUP.menu.admin.orderDetail.labels.due}: ${(order.balanceDue ? order.balanceDue : Number(0)).toFixed(2)}</h4>
                            <h4 className="nowrap">{LOOKUP.menu.admin.orderDetail.labels.change}: ${(order.change ? order.change : Number(0)).toFixed(2)}</h4>
                            <h4 className="nowrap">{LOOKUP.menu.admin.orderDetail.labels.tips}: ${(order.tipAmount ? order.tipAmount : Number(0)).toFixed(2)}</h4>
                            {
                                order && order.payments && order.payments.length > 0 && (<div>
                                    <h4 className="nowrap">{LOOKUP.menu.admin.orderDetail.labels.payments}</h4>
                                    {
                                        order.payments.map((item, index) => {
                                            return (
                                                <h4 className="nowrap" key={index}>{item.name}: ${item.value.toFixed(2)}</h4>
                                            );
                                        })
                                    }
                                </div>)
                            }
                        </div>
                        <div class="col-md-6 text-right  p-2" style={{ flex: `0 0 40%` }}>
                            {/* {order && order.qrCode && 
                            <React.Fragment>
                                {!order.qrCode.includes(`TSS-JWToken`) ? ( order.qrCode[order.qrCode.length-1] == 'TSS is not available' ?
                                <div> {order.qrCode[order.qrCode.length-1]} </div> : 
                                <QRCodeSVG value={order.qrCode[order.qrCode.length-1]} size={128} />) : order.qrCode} 
                                
                            </React.Fragment>} */}
                        </div>
                    </div>
                </div>
            </div>
        ) : null;
    }
}


function mapStateToProps(state){
    return {
        store: state.common.store
    };
}

export default connect(mapStateToProps) (OrderPrintInvoice);